module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header">\r\n    <h1>\r\n        FAQQQQQQQQQQ\r\n    </h1>\r\n</section>\r\n\r\n<section class="content">\r\n    <div class="row">\r\n        <div class="col-md-12 folderView">\r\n\r\n        </div>\r\n    </div>\r\n</section>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/faq/faqView.ejs
// module id = 417
// module chunks = 0